import React, { useEffect, useState } from "react";
import {
  AdminNavigation,
  Title,
  Input,
  Button,
  Modal,
  MenuBar,
} from "../../../components";
// import styles from "./styles.module.css";
import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useToast, CircularProgress, Center } from "@chakra-ui/react";
import { FaWrench, FaTrashAlt } from "react-icons/fa";
import {
  addTag,
  editTag,
  fetchTag,
  removeTag,
} from "../../../redux/actions/admin/tagActions";
import {
  CREATE_TAG_RESET,
  DELETE_TAG_RESET,
  UPDATE_TAG_RESET,
} from "../../../redux/constants/admin/tagConstants";

const Tag = () => {
  const ptitle = "Tag";
  const dispatch = useDispatch();
  const toast = useToast();
  //   const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [tagName, setTagName] = useState("");
  const [id, setID] = useState(null);

  useEffect(() => {
    dispatch(fetchTag());
  }, [dispatch]);

  const openHandler = () => {
    setOpen(true);
    setEdit(false);
    setTagName("");
  };

  // states
  const createTag = useSelector((state) => state.createTag);
  const { loading, error, success } = createTag;
  const updateTag = useSelector((state) => state.updateTag);
  const { loading: uLoading, error: uError, success: uSuccess } = updateTag;
  const deleteTag = useSelector((state) => state.deleteTag);
  const { loading: dLoading, error: dError, success: dSuccess } = deleteTag;
  const getTags = useSelector((state) => state.getTags);
  const { tags = [] } = getTags;

  const columns = [{ title: "Tag", field: "tagName" }];

  const deleteHandler = (id) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete this ${ptitle}`,
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(removeTag(id));
      }
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!tagName) {
      toast({
        title: "Warning!",
        description: "Enter Name",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(addTag(tagName));
    }
  };

  const editHandler = (e) => {
    e.preventDefault();
    if (!tagName) {
      toast({
        title: "Warning!",
        description: "Enter Name",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(editTag(tagName, id));
    }
  };

  if (error || uError || dError) {
    toast({
      title: "Error",
      description: error || uError || dError,
      status: "error",
      duration: 9000,
      isClosable: true,
    });
    error && dispatch({ type: CREATE_TAG_RESET });
    uError && dispatch({ type: UPDATE_TAG_RESET });
    dError && dispatch({ type: DELETE_TAG_RESET });
  }

  if (success || uSuccess || dSuccess) {
    toast({
      title: "Notification",
      description: `Sucesss`,
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    setOpen(false);
    dispatch(fetchTag());
    success && dispatch({ type: CREATE_TAG_RESET });
    uSuccess && dispatch({ type: UPDATE_TAG_RESET });
    dSuccess && dispatch({ type: DELETE_TAG_RESET });
  }

  // Menubar Items
  const menu = [
    { name: "Helpdesk Teams", url: "/admin/config" },
    { name: "Ticket Type", url: "/admin/config/ticketType" },
    { name: "Stages", url: "/admin/config/stages" },
    { name: "Stage Level", url: "/admin/config/stagelevel" },
    { name: "SLA Policies", url: "/admin/config/sla" },
    { name: "Priority", url: "/admin/config/priority" },
    { name: "Tag", url: "/admin/config/tag", active: true },
    { name: "Exclude Stage", url: "/admin/config/excludeStage" },
  ];

  return (
    <div className="appContainer">
      <AdminNavigation />
      <div className="contentsRight">
        <Title title={ptitle} type="Admin" />
        <MenuBar menu={menu} />
        <div className="btnContainer right">
          <button type="button" onClick={openHandler} className="btn teal">
            Add {ptitle}
          </button>
        </div>
        {dLoading ? (
          <Center>
            <CircularProgress isIndeterminate color="#3AB29A" />
          </Center>
        ) : (
          <MaterialTable
            title=""
            columns={columns}
            data={tags}
            options={{
              exportAllData: true,
              exportButton: true,
              actionsCellStyle: {
                backgroundColor: "none",
                color: "#FF00dd",
              },
              actionsColumnIndex: -1,

              headerStyle: {
                backgroundColor: "#dcdcdc",
                color: "black",
                fontWeight: "bold",
              },
            }}
            style={{
              boxShadow: "none",
              width: "100%",
              background: "none",
              fontSize: "13px",
            }}
            actions={[
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Update",
                onClick: (event, rowData) => {
                  setOpen(true);
                  setEdit(true);
                  setTagName(rowData.tagName);
                  setID(rowData.id);
                },
                title: "Update",
                color: "teal",
                Icon: FaWrench,
              },
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  deleteHandler(rowData.id);
                },
                title: "Delete",
                color: "gold",
                Icon: FaTrashAlt,
              },
            ]}
            components={{
              Action: (props) => (
                <button
                  onClick={(event) => props.action.onClick(event, props.data)}
                  className={`btnTable ${props.action.color}`}
                >
                  <props.action.Icon />
                  {props.action.title}
                </button>
              ),
            }}
          />
        )}
        <Modal
          isVisible={open}
          title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
          size="lg"
          content={
            <form onSubmit={edit ? editHandler : submitHandler}>
              <div className="nirsal__InputFlex">
                <Input
                  type="text"
                  onChange={(e) => setTagName(e.target.value)}
                  value={tagName}
                  required={true}
                  title="Name"
                  size="large"
                />
                <Button
                  title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
                  type="submit"
                  isFullWidth={true}
                  size="lg"
                  loading={loading || uLoading}
                />
              </div>
            </form>
          }
          onClose={() => setOpen(false)}
        />
      </div>
    </div>
  );
};

export default Tag;
